import {TranslatedKeys} from 'shared/types/translated-keys';

export interface BaseAdditionalProps {
  id: string;
  name: string;
  description?: string;
  image?: string;
}

export const translatedBaseAdditionalProps: TranslatedKeys<BaseAdditionalProps> =
  {
    name: 'Nome',
    description: 'Descrição',
    image: 'Imagem',
  };
